import React from "react";
import { SelectInput } from "../../lib";

const RoleInput = ({ onChange, autoFocus, ...rest }) => {
  return (
    <SelectInput
      {...rest}
      className="RoleInput"
      autoFocus
      onChange={v => onChange(v, true)}
    >
      <option disabled selected hidden>
        Please choose...
      </option>
      {[
        "Lead Pastor",
        "Executive Pastor",
        "Multisite Director",
        "Campus Pastor",
        "Board Member or Elder",
        "Administrative Support",
        "Family Ministry / Groups",
        "Worship / Creative Arts",
        "Denomination / Network Leader",
        "Communications",
        "Other"
      ].map(role => (
        <option value={role} key={role}>
          {role}
        </option>
      ))}
    </SelectInput>
  );
};

RoleInput.displayName = "RoleInput";

export default RoleInput;



// WEBPACK FOOTER //
// ./src/assess/question/RoleInput.js